import { LinkOptions } from './types';
import {
  QH_DEALS_URL,
  QH_LUXE_URL,
  QH_PACKAGES_URL,
  QCOM_LANDING_PAGE_URL,
  CONTACT_US,
  QCOM_PRIVACY_AND_SECURITY_URL,
  QCOM_TERMS_OF_USE_URL,
  DESTINATIONS_AUSTRALIA,
  FAQS,
  QFF_MY_ACCOUNT_URL,
  QFF_MY_PROFILE_URL,
  QFF_MY_POINTS_ACTIVITY_URL,
  QH_SELF_SERVICE_URL,
  QH_LIST_URL,
} from '../../lib/config';

export const desktopLinks: LinkOptions[] = [
  {
    trackingName: 'Hotels',
    href: QH_LIST_URL,
    'data-testid': 'hotels-link',
    children: 'Hotels',
    rel: 'noreferrer noopener',
    target: '_blank',
  },
  {
    trackingName: 'Hotels Deals',
    href: QH_DEALS_URL,
    'data-testid': 'deals-link',
    children: 'Hotel Deals',
    rel: 'noreferrer noopener',
    target: '_blank',
  },
  {
    trackingName: 'Luxury Offers',
    href: QH_LUXE_URL,
    'data-testid': 'luxe-link',
    children: 'Luxury Offers',
    rel: 'noreferrer noopener',
    target: '_blank',
  },
  {
    trackingName: 'Holidays',
    href: QH_PACKAGES_URL,
    'data-testid': 'holidays-link',
    children: 'Holidays',
    rel: 'noreferrer noopener',
    target: '_blank',
  },
  {
    trackingName: 'Airbnb',
    href: QCOM_LANDING_PAGE_URL,
    'data-testid': 'airbnb-link',
    children: 'Airbnb',
    rel: 'noreferrer noopener',
    target: '_blank',
  },
];

export const phoneLinks: LinkOptions[] = [
  ...desktopLinks,
  {
    trackingName: 'Phone Contact',
    href: CONTACT_US,
    'data-testid': 'phone-contact-link',
    children: 'Contact',
  },
  {
    trackingName: 'Phone Privacy Security',
    href: QCOM_PRIVACY_AND_SECURITY_URL,
    'data-testid': 'phone-privacy-security-link',
    children: 'Privacy & Security',
  },
  {
    trackingName: 'Phone Term Of Use',
    href: QCOM_TERMS_OF_USE_URL,
    'data-testid': 'phone-term-of-use-link',
    children: 'Terms of use',
  },
  {
    trackingName: 'Phone Australian Destinations',
    href: DESTINATIONS_AUSTRALIA,
    'data-testid': 'phone-australian-destinations-link',
    children: 'Australian destinations',
  },
  {
    trackingName: 'Phone Faqs',
    href: FAQS,
    'data-testid': 'phone-faqs-link',
    children: 'FAQs',
  },
];

export const qffLinks: LinkOptions[] = [
  {
    trackingName: 'My Account',
    href: QFF_MY_ACCOUNT_URL,
    target: '_blank',
    rel: 'noreferrer noopener',
    'data-testid': 'my-account-link',
    children: 'My account',
  },
  {
    trackingName: 'My Hotel Bookings',
    href: QH_SELF_SERVICE_URL,
    target: '_blank',
    rel: 'noreferrer noopener',
    'data-testid': 'my-bookings-link',
    children: 'My hotel bookings',
  },
  {
    trackingName: 'My Points Activity',
    href: QFF_MY_POINTS_ACTIVITY_URL,
    target: '_blank',
    rel: 'noreferrer noopener',
    'data-testid': 'my-points-link',
    children: 'My points activity',
  },
  {
    trackingName: 'My Profile',
    href: QFF_MY_PROFILE_URL,
    target: '_blank',
    rel: 'noreferrer noopener',
    'data-testid': 'my-profile-link',
    children: 'My profile',
  },
];
